var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-100"},[_c('h3',{staticClass:"title text-2xl font-medium"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }